<script lang="ts" setup>
import { goDiscordLink } from "@/use/go";
import { ref } from "vue";
import { useRouter } from "vue-router";
import { inApp } from "@/modules/common";

const router = useRouter();
const year = new Date().getFullYear();
const isCN = !!import.meta.env.VITE_IS_CN;
const showPolicy = ref(false);
const policyType = ref<"privacy-policy-cn" | "user-agreement-cn">(
  "privacy-policy-cn"
);

const clickPolicy = (type: "privacy-policy-cn" | "user-agreement-cn") => {
  policyType.value = type;
  showPolicy.value = true;
};
</script>
<template>
  <div class="lg:pt-[var(--top-nav-height)]">
    <ThreadsNav :show-center="false" class="lg:hidden" show-back />
    <div class="flex flex-col text-sm">
      <div class="flex flex-col items-center justify-center gap-2">
        <img
          alt="logo"
          class="w-[5rem] rounded-xl"
          src="/img/logo/logo-square.webp"
        />
        <div class="flex flex-col gap-2 items-center justify-center">
          <div v-if="isCN" class="text-shadow text-base-content/80 text-center">
            <template v-if="inApp">
              <div>京ICP备2025113882号-2A</div>
              <p>{{ "@" + year }} 饼次元</p>
            </template>
            <template v-else>
              <div>京ICP备2025113882号</div>
              <p>{{ "@" + year }} 饼次元</p>
            </template>
          </div>
        </div>
      </div>
      <div class="mt-4">
        <CellItem
          v-if="false"
          icon="mingcute--discord-fill"
          is-out-link
          label="Discord"
          @click="goDiscordLink"
        />
      </div>
      <div class="border-t">
        <!-- <div class="p-4 font-bold text-base">{{ $t("About.policies") }}</div> -->
        <CellItem
          :label="$t('loginmodal.privacyPolicy')"
          is-link
          @click="clickPolicy('privacy-policy-cn')"
        />
        <CellItem
          :label="$t('loginmodal.userAgreement')"
          is-link
          @click="clickPolicy('user-agreement-cn')"
        />
        <!-- <CellItem
          :label="$t('About.communityGuidelines')"
          is-link
          @click="
            router.push({
              name: 'policy',
              query: { type: 'community-guidelines' },
            })
          "
        />
        <CellItem
          :label="$t('About.contentRemovalPolicy')"
          is-link
          @click="
            router.push({
              name: 'policy',
              query: { type: 'content-removal-policy' },
            })
          "
        />
        <CellItem
          :label="$t('About.ComplaintsPolicy')"
          is-link
          @click="
            router.push({
              name: 'policy',
              query: { type: 'complaints-policy' },
            })
          "
        /> -->
      </div>
    </div>

    <ModalPolicyPage v-model:show="showPolicy" :docType="policyType" />
  </div>
</template>
